import React from 'react'
import { IconButton, Tooltip } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import AppButton from '../../../components/global/AppButton'
import SyncPriceButton from '../../../components/global/SyncPriceButton'

const legacyRefreshProducts = ['selected']

export default function PricePrimaryActions({ builder, refresh, pricesUrl, disabled, refreshDisabled, onQuery, onInfo, onSyncComplete, onSyncStateChange, onConfirmationStateChange, onError }) {
    return (
        <>
            <AppButton disabled={disabled} variant='outlined' size='small' startIcon={<SearchIcon />} onClick={onQuery}>
                Query SAP
            </AppButton>
            <SyncPriceButton
                builder={builder}
                resumeProducts={legacyRefreshProducts}
                progressSuffix={refresh.progressSuffix}
                onSyncComplete={onSyncComplete}
                onSyncStateChange={onSyncStateChange}
                onConfirmationStateChange={onConfirmationStateChange}
                onError={onError}
                showInlineError={false}
                initialMessage={refresh.label}
                syncUrl={`${pricesUrl}/refresh`}
                syncMethod='post'
                syncParams={null}
                syncBody={refresh.body}
                buttonProps={{ size: 'small', disabled: refreshDisabled }}
                confirmation={refresh.confirmation}
            />
            <Tooltip title='How price refresh works'>
                <IconButton size='small' aria-label='How price refresh works' onClick={onInfo}>
                    <InfoOutlinedIcon fontSize='small' />
                </IconButton>
            </Tooltip>
        </>
    )
}
